export default (fn, delay) => {
  const id = setInterval(fn, delay)
  return () => {
    clearInterval(id)
  }
}
